import React, { useEffect, useRef, useState } from "react";

//routing
import { useParams } from "react-router-dom";

//schemas
import form from "./schema/form";
import validation from "./schema/validation";
import initialValues from "./schema/initialValues";

//external components
import { Box, Grid, CircularProgress } from "@mui/material";

//components
import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";

//pages
import Main from "./components/main";

// formik components
import { Formik, Form } from "formik";

//translation
import { useTranslation } from "react-i18next";

//hooks
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import { useSnackbar } from "notistack";
import useAuth from "../../../../hooks/useAuth";

//graphql
import {
	GET_CUSTOMER_BY_ID,
	UPDATE_CUSTOMER,
	CREATE_CUSTOMER,
} from "../../../../graphql/customer";

import { useNavigate } from "react-router-dom";

//urls

import ContainerCard from "../../../../components/Cards/ContainerCard";

import UTC2Local from "../../../../UTC2Local";
import urls from "../../../../urls";

const CustomerForm = ({
	fromModal = false,
	handleCloseModal,
	resetFields = false,
	fromTenant = false,
}) => {
	const { cName, cID } = useParams();
	const navigate = useNavigate();

	const { storeUserGuid, userRoles } = useAuth();

	const { manageParameters } = userRoles;

	const createMode = !cName && !cID;

	const { t } = useTranslation();

	const { formField } = form;

	const [sideInfoData, setSideInfoData] = useState({});

	const [unTouchedForm, setUnTouchedForm] = useState(true);

	const formikValuesRef = useRef(null);
	const formikRef = useRef(null);

	useEffect(() => {
		const handleKeyDown = (event) => {
			// Check for Ctrl + S
			if (event.key === "s" && event.ctrlKey) {
				event.preventDefault(); // Prevent the default behavior
				formikRef.current?.handleSubmit(formikValuesRef.current); // Submit the form
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		// Clean up the event listener on unmount
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	useEffect(() => {
		if (resetFields === true) {
			let f = document.getElementById(form.formID);
			f?.reset();
		}
	}, [resetFields]);
	const { my_customers_list } = urls;

	const { name, code, companyID } = formField;

	const { enqueueSnackbar } = useSnackbar();

	const [formData, setFormData] = useState(initialValues);

	const { loading: getDataByIDLoading, tokenChange: wait } = useQueryAuth(
		GET_CUSTOMER_BY_ID,
		"GetCustomer",
		{
			variables: { customerID: cID },
			skip: createMode,
		},
		{
			onCompleted: (response) => {
				const data = response?.GetCustomer?.customer || {};

				setFormData({
					[name.name]: data.name || "",
					[code.name]: data.code || "",
					[companyID.name]: data.company
						? {
								companyGuid: data.company.companyGuid,
								name: data.company.name,
							}
						: null,
				});

				setSideInfoData({
					"companyForm.createdBy": data.creatingUsers
						? data.creatingUsers.email
						: "",
					"companyForm.creationDate": UTC2Local(data.creationDate) || "",
					"companyForm.modifiedBy": data.modifiedUsers
						? data.modifiedUsers.email
						: "",
					"companyForm.modificationDate":
						UTC2Local(data.modificationDate) || "",
				});
			},
		}
	);

	const { cfunction: editCustomerData } = useMutationAuth(
		UPDATE_CUSTOMER,
		"EditCustomer"
	);

	const { cfunction: createCustomerData } = useMutationAuth(
		CREATE_CUSTOMER,
		"CreateCustomer"
	);

	function createCustomer(values, actions) {
		createCustomerData(
			{
				variables: {
					model: {
						name: values[name.name],
						userID: storeUserGuid,
						code: values[code.name],
						companyID:
							values[companyID.name] !== "" ||
							values[companyID.name] !== null ||
							values[companyID.name] !== null
								? values[companyID.name].companyGuid
								: null,
					},
				},
			},
			(response) => {
				if (
					response["CreateCustomer"].errorCode !== null &&
					response["CreateCustomer"].errorCode !== ""
				) {
					enqueueSnackbar(t(response["CreateCustomer"].errorMessage), {
						variant: "error",
						autoHideDuration: 5000,
					});
				} else {
					enqueueSnackbar(t("customerForm.createdSuccessfully"), {
						variant: "success",
					});
					sessionStorage.removeItem("unsavedChanges");

					if (fromModal !== true) {
						navigate(my_customers_list);
					}

					if (fromModal === true && handleCloseModal !== undefined)
						handleCloseModal(false);
				}
				actions.setSubmitting(false);
			},
			(error) => {
				actions.setSubmitting(false);
			}
		);
	}

	function editCustomer(values, actions) {
		editCustomerData(
			{
				variables: {
					model: {
						customerID: cID,
						name: values[name.name],
						userID: storeUserGuid,
						// code: values[code.name],
						// companyID:
						// 	values[companyID.name] !== "" ||
						// 	values[companyID.name] !== null ||
						// 	values[companyID.name] !== null
						// 		? values[companyID.name].companyGuid
						// 		: null,
					},
				},
			},
			(response) => {
				if (
					response["EditCustomer"].errorCode !== null &&
					response["EditCustomer"].errorCode !== ""
				) {
					enqueueSnackbar(t(response["EditCustomer"].errorMessage), {
						variant: "error",
						autoHideDuration: 5000,
					});
				} else {
					enqueueSnackbar(t("customerForm.updatedSuccessfully"), {
						variant: "success",
					});
					sessionStorage.removeItem("unsavedChanges");

					const data = response?.EditCustomer?.customer || {};
					setSideInfoData((oldValue) => ({
						...oldValue,
						"companyForm.modificationDate":
							UTC2Local(data.modificationDate) || "",
					}));
				}
				actions.setSubmitting(false);
			},
			(error) => {
				actions.setSubmitting(false);
			}
		);
	}

	useEffect(() => {
		if (
			performance.navigation.type === performance.navigation.TYPE_NAVIGATE &&
			unTouchedForm &&
			!fromModal
		) {
			sessionStorage.clear();
		}
	}, []);

	const handleSubmit = (values, actions) => {
		if (createMode) {
			createCustomer(values, actions);
		} else {
			editCustomer(values, actions);
		}
	};

	return (
		<>
			{getDataByIDLoading ? (
				<ContainerCard sx={{ height: "50vh" }}>
					<Box
						display="flex"
						justifyContent="center"
						alignItems="center"
						height="100%"
						width="100%"
					>
						<CircularProgress />
					</Box>
				</ContainerCard>
			) : (
				<Box mb={5}>
					<Grid
						container
						justifyContent="center"
						alignItems="stretch"
						sx={{ height: "100%", mt: 2 }}
						spacing={2}
					>
						<Grid item xs={12} sm={12} md={12} lg={createMode ? 12 : 9}>
							<ContainerCard>
								<Formik
									innerRef={formikRef}
									key={`${form.formID}-form-${
										createMode ? "creation" : "edit"
									}`}
									initialValues={formData}
									validationSchema={validation[1]}
									onSubmit={handleSubmit}
									enableReinitialize
								>
									{({
										dirty,
										values,
										errors,
										touched,
										isSubmitting,
										setFieldValue,
										setTouched,
									}) => {
										formikValuesRef.current = values;
										return (
											<Form
												id={form.formID}
												autoComplete="off"
												onChange={() => {
													if (touched && fromModal !== true) {
														sessionStorage.setItem(
															"unsavedChanges",
															JSON.stringify(true)
														);
														setUnTouchedForm(false);
													}
												}}
											>
												<Box p={2}>
													<Box>
														<Main
															formData={{
																values,
																touched,
																formField: form.formField,
																errors,
																setFieldValue,
																setTouched,
																createMode,
																wait,
																readOnly:
																	manageParameters === "R",
																fromTenant,
															}}
														/>
													</Box>
													<Box
														mt={2}
														width="100%"
														display="flex"
														justifyContent="flex-end"
													>
														<IALoadingButton
															disabled={
																isSubmitting ||
																manageParameters !== "M"
															}
															loading={isSubmitting}
															type="submit"
															label={t("companyForm.save")}
														/>
													</Box>
												</Box>
											</Form>
										);
									}}
								</Formik>
							</ContainerCard>
						</Grid>
						{/* {!createMode ? (
							<Grid item xs={12} sm={12} md={12} lg={3}>
								<ContainerCard
									sx={{
										boxShadow: "0px 0px 10px rgba(24,117,214,255)",
									}}
								>
									<Box p={3}>
										<SideInfo data={Object.entries(sideInfoData)} />
									</Box>
								</ContainerCard>
							</Grid>
						) : null} */}
					</Grid>
				</Box>
			)}
		</>
	);
};

export default CustomerForm;
